var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.233887 15.71L7.7309 12.3733L12.0461 14.8758L12.9178 23.086L7.60016 23.0419L8.38471 17.3344L7.46938 16.8076L2.97987 20.3201L0.233887 15.71Z",
    fill: "#B4C0D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5259 14.5244L19.1513 19.3977L21.7664 14.7L16.4486 12.5487V11.495L21.7664 9.29975L19.1513 4.64587L12.5259 9.51929V14.5244Z",
    fill: "#00D3AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0461 9.12419L12.9178 0.914062L7.60016 1.00185L8.38471 6.70945L7.46938 7.2363L2.93629 3.72393L0.233887 8.28999L7.7309 11.6267L12.0461 9.12419Z",
    fill: "#4876EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon01);
export default __webpack_public_path__ + "static/media/company-icon-01.f63470637b94c9ae17f0ac180cdc78da.svg";
export { ForwardRef as ReactComponent };